export default __webpack_public_path__ + "static/media/flouride.f1f79561.png";